import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";

const gymMemberList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "gym/bta-member-list", data, headerConfig);
        return response;
};

const gymNonMemberList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "gym/bta-non-member-list", data, headerConfig);
        return response;
};

const gymRateList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "gym/gym-rate", data, headerConfig);
        return response;
};


const enrollmentGYMSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "gym/enrollment", data, headerConfig);
        return response;
};

const gymListAll = async () => {
    const response = await axios
        .post(BASE_API_URL + "gym/gym-member-list-all", {}, headerConfig);
        return response;
};

const gymMemberDetail = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "gym/gym-member-details", data, headerConfig);
        return response;
};


const gymService = {
    gymMemberList,
    gymNonMemberList,
    gymRateList,
    enrollmentGYMSave,
    gymListAll,
    gymMemberDetail
};

export default gymService;